"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformOrganizationApi = exports.SdPlatformOrganizationEmbeddableFields = void 0;
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
const ResourcesApi_1 = require("./commons/ResourcesApi");
var SdPlatformOrganizationEmbeddableFields;
(function (SdPlatformOrganizationEmbeddableFields) {
    SdPlatformOrganizationEmbeddableFields["AccessDomains"] = "accessdomains";
    SdPlatformOrganizationEmbeddableFields["BackendSystem"] = "backend_system";
    SdPlatformOrganizationEmbeddableFields["Members"] = "members";
    SdPlatformOrganizationEmbeddableFields["ChargebeeCustomer"] = "chargebee_customer";
    SdPlatformOrganizationEmbeddableFields["ChargebeeSubscription"] = "chargebee_subscription";
    SdPlatformOrganizationEmbeddableFields["ChargebeePlan"] = "chargebee_plan";
    SdPlatformOrganizationEmbeddableFields["ChargebeeAddons"] = "chargebee_addons";
    SdPlatformOrganizationEmbeddableFields["OpenIdProvider"] = "openid_provider";
    SdPlatformOrganizationEmbeddableFields["UsedCredits"] = "used_credits";
})(SdPlatformOrganizationEmbeddableFields = exports.SdPlatformOrganizationEmbeddableFields || (exports.SdPlatformOrganizationEmbeddableFields = {}));
/**
 * Operations for organizations.
 */
class SdPlatformOrganizationApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "organizations";
    }
    /**
    * Get organization by id.
    * @param id - organization id.
    * @param embed array of {@link SdPlatformOrganizationEmbeddableFields} embeddable resources.
    * @returns the {@link SdPlatformGetResponse} response with {@link SdPlatformResponseOrganizationPublic} or derived interfaces as result.
    */
    get(id, embed) {
        return super.__get(SdPlatformRequestId_1.RequestId.OrganizationGet, id, embed);
    }
    /**
     * Query organizations.
     * @param body {@link SdPlatformOrganizationQueryParameters}
     * @returns the {@link SdPlatformQueryResponse} with {@link SdPlatformResponseOrganizationPublic} or one of it's derived interfaces as data result.
     */
    query(body = {}) {
        return super.__query(SdPlatformRequestId_1.RequestId.OrganizationQuery, body);
    }
    /**
     * Create an organization, and make the calling user owner of the organization. Will fail in case the user is member of an organization already.
     * @param body {@see SdPlatformRequestOrganizationCreate}
     * @returns the {@link SdPlatformPostResponse} with {@see SdPlatformResponseOrganizationOwner} as data.
     */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.OrganizationCreate, body);
    }
    /**
     * Patch an organization.
     * @param id - id of the organization
     * @param body {@link SdPlatformRequestOrganizationPatchAny} properties to patch
     * @response the {@link SdPlatformPatchResponse} with {@link SdPlatformResponseOrganizationAdministrator} or one of it's derived interfaces as data.
     */
    patch(id, body) {
        return super.__patch(SdPlatformRequestId_1.RequestId.OrganizationPatch, id, body);
    }
    /**
     * Delete an organization.
     * @param id
     * @returns
     */
    delete(id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.OrganizationDelete, id);
    }
    /**
     * Create organization invitation.
     * @param organization_id
     * @param receiver_id
     * @returns
     */
    createOrganizationInvitation(organization_id, receiver_id) {
        return super.__action(SdPlatformRequestId_1.RequestId.OrganizationInvitationCreate, ResourcesApi_1.Action.Post, `${organization_id}/invitation/${receiver_id}`, {});
    }
    /**
     * Delete organization invitation.
     * @param organization_id
     * @param id receiver id OR notification id in case of email notification
     * @returns
     */
    deleteOrganizationInvitation(organization_id, id) {
        return super.__action(SdPlatformRequestId_1.RequestId.OrganizationInvitationDelete, ResourcesApi_1.Action.Delete, `${organization_id}/invitation/${id}`, {});
    }
    /**
     * Get organization invitations.
     * @param organization_id
     * @returns
     */
    getOrganizationInvitations(organization_id) {
        return super.__action(SdPlatformRequestId_1.RequestId.OrganizationInvitationsGet, ResourcesApi_1.Action.Get, `${organization_id}/invitation`, {});
    }
    /**
     * Accept organization invitation.
     * @param organization_id
     * @returns
     */
    acceptOrganizationInvitation(organization_id) {
        return super.__action(SdPlatformRequestId_1.RequestId.OrganizationInvitationAccept, ResourcesApi_1.Action.Post, `${organization_id}/invitation_accept`, {});
    }
    /**
     * Deny organization invitation.
     * @param organization_id
     * @returns
     */
    denyOrganizationInvitation(organization_id) {
        return super.__action(SdPlatformRequestId_1.RequestId.OrganizationInvitationDeny, ResourcesApi_1.Action.Post, `${organization_id}/invitation_deny`, {});
    }
    /**
     * Patch role of organization member.
     * @param organization_id
     * @param user_id
     * @param body {@link SdPlatformRequestOrganizationPatchMemberRole} properties to patch
     */
    patchMemberRole(organization_id, user_id, body) {
        return super.__action(SdPlatformRequestId_1.RequestId.OrganizationPatchMemberRole, ResourcesApi_1.Action.Patch, `${organization_id}/user/${user_id}`, body);
    }
    /**
     * Invite user to organization by email.
     * @param organization_id
     * @param email
     */
    invitationByEmail(organization_id, email) {
        return super.__action(SdPlatformRequestId_1.RequestId.OrganizationInvitationByEmail, ResourcesApi_1.Action.Post, `${organization_id}/invitation_by_email`, {
            email: email
        });
    }
    /**
     * Get the SSO provider name of organization.
     * @param email - organization 'email' or 'domain' of an organization should be passed in.
     * @returns
     */
    identifySSO(email) {
        return super.__action(SdPlatformRequestId_1.RequestId.OrganizationIdentifySSO, ResourcesApi_1.Action.Get, `identify_sso`, {
            email: email
        });
    }
    /**
     * Get organization tokens based backend system.
     * @param id - the id of an organization
     * @param body {@link SdPlatformRequestOrganizationToken}
     */
    token(id, body) {
        return super.__action(SdPlatformRequestId_1.RequestId.OrganizationToken, ResourcesApi_1.Action.Post, `${id}/token`, body);
    }
}
exports.SdPlatformOrganizationApi = SdPlatformOrganizationApi;
//# sourceMappingURL=SdPlatformOrganizationApi.js.map